export enum StrategyType {
  STANDARD,
  GAMMA,
  BMARK,
}

export namespace StrategyType {
  let elements = [StrategyType.STANDARD, StrategyType.GAMMA, StrategyType.BMARK];
  let alias = "com.bcdfx.model.StrategyType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
